/**
 * Legend outside the Recharts SVG so it never reflows the plot mid-animation
 * (built-in <Legend /> cancels the Area/Line fly-in).
 */
export function NbsChartLegend({
  seriesKeys,
  colors,
}: {
  readonly seriesKeys: readonly string[];
  readonly colors: readonly string[];
}) {
  if (seriesKeys.length === 0) return null;

  return (
    <ul className="nbs-chart-legend" aria-label="Légende">
      {seriesKeys.map((key, i) => (
        <li key={key} className="nbs-chart-legend__item">
          <span
            className="nbs-chart-legend__swatch"
            style={{ background: colors[i % colors.length] }}
            aria-hidden="true"
          />
          <span className="nbs-chart-legend__label">{key}</span>
        </li>
      ))}
    </ul>
  );
}
